export const IS_LOGGED_IN_COOKIE_NAME = 'isLoggedIn'
export const DATETIME_FORMAT = 'MMMM Do YYYY, h:mm a'
export const DATE_FORMAT = 'MMMM D, YYYY'
export const SHORT_DATE_FORMAT = 'MMM. D, YYYY'
export const SHORT_DATETIME_FORMAT = 'MMM. D, YYYY @ h:mm a'
export const SHORT_DATETIME_NO_YEAR_FORMAT = 'MMM. D @ h:mm a'

export const EDITOR_MODE_HTML = 'html'
export const EDITOR_MODE_MARKDOWN = 'markdown'

export const POST_TYPE_POST = 'POST'
export const POST_TYPE_LINK = 'LINK'
export const POST_TYPE_IMAGE = 'IMAGE'

export const BILLING_TERM_MONTH = 'MONTHLY'
export const BILLING_TERM_YEAR = 'YEARLY'

export const daysOfTheWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]
